import { render, staticRenderFns } from "./request-modal.vue?vue&type=template&id=1b049d41&scoped=true"
import script from "./request-modal.vue?vue&type=script&lang=js"
export * from "./request-modal.vue?vue&type=script&lang=js"
import style0 from "./request-modal.vue?vue&type=style&index=0&id=1b049d41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b049d41",
  null
  
)

export default component.exports